import React from 'react';
import styled from 'styled-components';

const Section = styled.section` padding: 5rem 1rem; background: var(--background-dark); `;
const Inner = styled.div` max-width: 1200px; margin: 0 auto; `;

const Head = styled.div`
  text-align: center; max-width: 720px; margin: 0 auto 3rem;
  .tag {
    display: inline-block;
    padding: 0.35rem 0.9rem; border-radius: 999px;
    border: 1px solid rgba(255,255,255,0.15);
    background: rgba(0,153,0,0.08); color: var(--primary-color);
    font-size: 0.75rem; font-weight: 700; letter-spacing: 0.08em; text-transform: uppercase;
    margin-bottom: 1rem;
  }
  h2 { font-size: clamp(1.75rem, 3.2vw, 2.5rem); margin: 0 0 0.75rem; color: var(--text-color); span { color: var(--primary-color); } }
  p { color: var(--text-secondary); line-height: 1.7; margin: 0; }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
  @media (max-width: 900px) { grid-template-columns: 1fr; }
`;

const Card = styled.article`
  background: rgba(255,255,255,0.03);
  border: 1px solid rgba(0, 153, 0, 0.15);
  border-radius: var(--border-radius);
  padding: 1.75rem;
  transition: transform 0.25s ease, border-color 0.25s ease;
  &:hover { transform: translateY(-4px); border-color: var(--primary-color); }

  .chip {
    display: inline-block; padding: 0.3rem 0.7rem; border-radius: 999px;
    background: rgba(0,153,0,0.15); color: var(--primary-color);
    font-size: 0.7rem; font-weight: 800; letter-spacing: 0.05em;
    margin-bottom: 0.75rem;
  }
  h3 { margin: 0 0 0.5rem; color: var(--text-color); font-size: 1.25rem; span { color: var(--primary-color); font-weight: 400; margin-left: 0.4rem; font-size: 0.85rem; } }
  .lede { color: var(--text-secondary); font-size: 0.95rem; line-height: 1.55; margin: 0 0 1.25rem; }
  dl { margin: 0; }
  dt { color: var(--text-secondary); font-size: 0.75rem; letter-spacing: 0.05em; text-transform: uppercase; margin-top: 0.75rem; }
  dd { color: var(--text-color); margin: 0.2rem 0 0; font-size: 0.95rem; }
`;

const NETWORKS = [
  {
    chip: 'Most popular',
    name: 'TRC-20',
    parent: 'Tron',
    lede: 'Cheapest and fastest confirmations. Best for high-volume flashing and P2P workflows.',
    rows: [
      ['Best for', 'P2P, OTC, high-volume demos'],
      ['Typical fee', 'Very low (<$1)'],
      ['Wallet fit', 'Trust Wallet, TronLink, Binance'],
      ['Explorer', 'Tronscan'],
    ],
  },
  {
    chip: 'DeFi-first',
    name: 'ERC-20',
    parent: 'Ethereum',
    lede: 'The standard for MetaMask and DeFi-heavy workflows. Great for institutional demos.',
    rows: [
      ['Best for', 'MetaMask users, DeFi demos, dApp QA'],
      ['Typical fee', 'Higher (gas dependent)'],
      ['Wallet fit', 'MetaMask, Coinbase, Ledger'],
      ['Explorer', 'Etherscan'],
    ],
  },
  {
    chip: 'BNB ecosystem',
    name: 'BEP-20',
    parent: 'BNB Smart Chain',
    lede: 'Low fees + broad Binance-ecosystem adoption. Balanced between TRC-20 speed and ERC-20 reach.',
    rows: [
      ['Best for', 'Binance users, launchpads, low-fee demos'],
      ['Typical fee', 'Low'],
      ['Wallet fit', 'Binance Wallet, MetaMask (BSC), SafePal'],
      ['Explorer', 'BscScan'],
    ],
  },
];

const NetworkComparison: React.FC = () => (
  <Section id="networks">
    <Inner>
      <Head>
        <div className="tag">TRC-20 · ERC-20 · BEP-20</div>
        <h2>Which network is right for <span>your flash USDT?</span></h2>
        <p>All plans support all three chains. Pick the one your audience already uses so wallet UI, explorers, and screenshots stay consistent end to end.</p>
      </Head>
      <Grid>
        {NETWORKS.map((n) => (
          <Card key={n.name}>
            <span className="chip">{n.chip}</span>
            <h3>{n.name} <span>({n.parent})</span></h3>
            <p className="lede">{n.lede}</p>
            <dl>
              {n.rows.map(([k, v]) => (<React.Fragment key={k}><dt>{k}</dt><dd>{v}</dd></React.Fragment>))}
            </dl>
          </Card>
        ))}
      </Grid>
    </Inner>
  </Section>
);

export default NetworkComparison;
